/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VideoStatsRouteImport } from './routes/video-stats'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as PendingRouteImport } from './routes/pending'
import { Route as LinksRouteImport } from './routes/links'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as ChannelLinkStatsRouteImport } from './routes/channel-link-stats'
import { Route as BlocksRouteImport } from './routes/blocks'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BatchBatchIdRouteImport } from './routes/batch.$batchId'
import { Route as VideoVideoIdLinkStatsRouteImport } from './routes/video.$videoId.link-stats'
import { Route as LinkDetailLinkIdVideoStatsRouteImport } from './routes/link-detail.$linkId.video-stats'

const VideoStatsRoute = VideoStatsRouteImport.update({
  id: '/video-stats',
  path: '/video-stats',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsRoute = StatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingRoute = PendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksRoute = LinksRouteImport.update({
  id: '/links',
  path: '/links',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const ChannelLinkStatsRoute = ChannelLinkStatsRouteImport.update({
  id: '/channel-link-stats',
  path: '/channel-link-stats',
  getParentRoute: () => rootRouteImport,
} as any)
const BlocksRoute = BlocksRouteImport.update({
  id: '/blocks',
  path: '/blocks',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchBatchIdRoute = BatchBatchIdRouteImport.update({
  id: '/batch/$batchId',
  path: '/batch/$batchId',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoVideoIdLinkStatsRoute = VideoVideoIdLinkStatsRouteImport.update({
  id: '/video/$videoId/link-stats',
  path: '/video/$videoId/link-stats',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkDetailLinkIdVideoStatsRoute =
  LinkDetailLinkIdVideoStatsRouteImport.update({
    id: '/link-detail/$linkId/video-stats',
    path: '/link-detail/$linkId/video-stats',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blocks': typeof BlocksRoute
  '/channel-link-stats': typeof ChannelLinkStatsRoute
  '/history': typeof HistoryRoute
  '/links': typeof LinksRoute
  '/pending': typeof PendingRoute
  '/stats': typeof StatsRoute
  '/video-stats': typeof VideoStatsRoute
  '/batch/$batchId': typeof BatchBatchIdRoute
  '/link-detail/$linkId/video-stats': typeof LinkDetailLinkIdVideoStatsRoute
  '/video/$videoId/link-stats': typeof VideoVideoIdLinkStatsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/blocks': typeof BlocksRoute
  '/channel-link-stats': typeof ChannelLinkStatsRoute
  '/history': typeof HistoryRoute
  '/links': typeof LinksRoute
  '/pending': typeof PendingRoute
  '/stats': typeof StatsRoute
  '/video-stats': typeof VideoStatsRoute
  '/batch/$batchId': typeof BatchBatchIdRoute
  '/link-detail/$linkId/video-stats': typeof LinkDetailLinkIdVideoStatsRoute
  '/video/$videoId/link-stats': typeof VideoVideoIdLinkStatsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blocks': typeof BlocksRoute
  '/channel-link-stats': typeof ChannelLinkStatsRoute
  '/history': typeof HistoryRoute
  '/links': typeof LinksRoute
  '/pending': typeof PendingRoute
  '/stats': typeof StatsRoute
  '/video-stats': typeof VideoStatsRoute
  '/batch/$batchId': typeof BatchBatchIdRoute
  '/link-detail/$linkId/video-stats': typeof LinkDetailLinkIdVideoStatsRoute
  '/video/$videoId/link-stats': typeof VideoVideoIdLinkStatsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blocks'
    | '/channel-link-stats'
    | '/history'
    | '/links'
    | '/pending'
    | '/stats'
    | '/video-stats'
    | '/batch/$batchId'
    | '/link-detail/$linkId/video-stats'
    | '/video/$videoId/link-stats'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blocks'
    | '/channel-link-stats'
    | '/history'
    | '/links'
    | '/pending'
    | '/stats'
    | '/video-stats'
    | '/batch/$batchId'
    | '/link-detail/$linkId/video-stats'
    | '/video/$videoId/link-stats'
  id:
    | '__root__'
    | '/'
    | '/blocks'
    | '/channel-link-stats'
    | '/history'
    | '/links'
    | '/pending'
    | '/stats'
    | '/video-stats'
    | '/batch/$batchId'
    | '/link-detail/$linkId/video-stats'
    | '/video/$videoId/link-stats'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlocksRoute: typeof BlocksRoute
  ChannelLinkStatsRoute: typeof ChannelLinkStatsRoute
  HistoryRoute: typeof HistoryRoute
  LinksRoute: typeof LinksRoute
  PendingRoute: typeof PendingRoute
  StatsRoute: typeof StatsRoute
  VideoStatsRoute: typeof VideoStatsRoute
  BatchBatchIdRoute: typeof BatchBatchIdRoute
  LinkDetailLinkIdVideoStatsRoute: typeof LinkDetailLinkIdVideoStatsRoute
  VideoVideoIdLinkStatsRoute: typeof VideoVideoIdLinkStatsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/video-stats': {
      id: '/video-stats'
      path: '/video-stats'
      fullPath: '/video-stats'
      preLoaderRoute: typeof VideoStatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats': {
      id: '/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof StatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending': {
      id: '/pending'
      path: '/pending'
      fullPath: '/pending'
      preLoaderRoute: typeof PendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links': {
      id: '/links'
      path: '/links'
      fullPath: '/links'
      preLoaderRoute: typeof LinksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/channel-link-stats': {
      id: '/channel-link-stats'
      path: '/channel-link-stats'
      fullPath: '/channel-link-stats'
      preLoaderRoute: typeof ChannelLinkStatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blocks': {
      id: '/blocks'
      path: '/blocks'
      fullPath: '/blocks'
      preLoaderRoute: typeof BlocksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batch/$batchId': {
      id: '/batch/$batchId'
      path: '/batch/$batchId'
      fullPath: '/batch/$batchId'
      preLoaderRoute: typeof BatchBatchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video/$videoId/link-stats': {
      id: '/video/$videoId/link-stats'
      path: '/video/$videoId/link-stats'
      fullPath: '/video/$videoId/link-stats'
      preLoaderRoute: typeof VideoVideoIdLinkStatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link-detail/$linkId/video-stats': {
      id: '/link-detail/$linkId/video-stats'
      path: '/link-detail/$linkId/video-stats'
      fullPath: '/link-detail/$linkId/video-stats'
      preLoaderRoute: typeof LinkDetailLinkIdVideoStatsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlocksRoute: BlocksRoute,
  ChannelLinkStatsRoute: ChannelLinkStatsRoute,
  HistoryRoute: HistoryRoute,
  LinksRoute: LinksRoute,
  PendingRoute: PendingRoute,
  StatsRoute: StatsRoute,
  VideoStatsRoute: VideoStatsRoute,
  BatchBatchIdRoute: BatchBatchIdRoute,
  LinkDetailLinkIdVideoStatsRoute: LinkDetailLinkIdVideoStatsRoute,
  VideoVideoIdLinkStatsRoute: VideoVideoIdLinkStatsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
